var map = {
	"./ecommerce/api/automatedPayment.md": [
		4099,
		99
	],
	"./ecommerce/api/endpoints.md": [
		3598,
		598
	],
	"./ecommerce/api/referencedPayments.md": [
		5764,
		764
	],
	"./ecommerce/api/webServices3DSecure.md": [
		283,
		283
	],
	"./ecommerce/api/wordpressEcom.md": [
		6915,
		915
	],
	"./ecommerce/dash/api-keys.md": [
		421,
		421
	],
	"./ecommerce/dash/chargebacks.md": [
		9273,
		273
	],
	"./ecommerce/dash/hotlink.md": [
		6807,
		807
	],
	"./ecommerce/dash/introduction.md": [
		1734,
		734
	],
	"./ecommerce/dash/profile.md": [
		87,
		87
	],
	"./ecommerce/dash/scheduledCharge.md": [
		6684,
		684
	],
	"./ecommerce/dash/transactionLog.md": [
		6379,
		379
	],
	"./ecommerce/dash/transactionView.md": [
		3606,
		606
	],
	"./en/ecommerce/api/automatedPayment.md": [
		2838,
		838
	],
	"./en/ecommerce/api/endpoints.md": [
		3077,
		77
	],
	"./en/ecommerce/api/referencedPayments.md": [
		4712,
		814
	],
	"./en/ecommerce/api/webServices3DSecure.md": [
		3482,
		482
	],
	"./en/ecommerce/api/wordpressEcom.md": [
		6850,
		850
	],
	"./en/ecommerce/dash/api-keys.md": [
		4041,
		41
	],
	"./en/ecommerce/dash/chargebacks.md": [
		916,
		916
	],
	"./en/ecommerce/dash/hotlink.md": [
		9353,
		353
	],
	"./en/ecommerce/dash/introduction.md": [
		5076,
		76
	],
	"./en/ecommerce/dash/profile.md": [
		6596,
		596
	],
	"./en/ecommerce/dash/scheduledCharge.md": [
		2263,
		263
	],
	"./en/ecommerce/dash/transactionLog.md": [
		8840,
		840
	],
	"./en/ecommerce/dash/transactionView.md": [
		815,
		815
	],
	"./en/mpos/app/hotlink.md": [
		4748,
		748
	],
	"./en/mpos/app/merchant.md": [
		6072,
		72
	],
	"./en/mpos/app/mpos.md": [
		490,
		490
	],
	"./en/mpos/app/payments.md": [
		5206,
		206
	],
	"./en/mpos/app/transaction.md": [
		3735,
		712
	],
	"./en/mpos/app/user.md": [
		9503,
		503
	],
	"./en/mpos/dashboard/myCommerce.md": [
		729,
		457
	],
	"./en/mpos/dashboard/transactions.md": [
		2777,
		777
	],
	"./mpos/api/cancelTrans.md": [
		1760,
		760
	],
	"./mpos/api/respaldo.md": [
		9657,
		657
	],
	"./mpos/api/voucher.md": [
		3926,
		926
	],
	"./mpos/app/hotlink.md": [
		3368,
		368
	],
	"./mpos/app/merchant.md": [
		2201,
		201
	],
	"./mpos/app/mpos.md": [
		7560,
		560
	],
	"./mpos/app/payments.md": [
		1666,
		666
	],
	"./mpos/app/transaction.md": [
		605,
		605
	],
	"./mpos/app/user.md": [
		8555,
		555
	],
	"./mpos/dashboard/myCommerce.md": [
		7664,
		664
	],
	"./mpos/dashboard/transactions.md": [
		3119,
		119
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7417;
module.exports = webpackAsyncContext;